export const getFilterOperators = type => {
  switch (type) {
    case 'search':
      return ['is'];
    case 'datetime':
      return ['gt', 'gte', 'lt', 'lte', 'between', 'missing'];
    case 'date':
      return ['gt', 'gte', 'lt', 'lte', 'between', 'missing'];
    case 'boolean':
      return ['in', 'missing'];
    case 'number':
      return ['in', 'gt', 'gte', 'lt', 'lte', 'missing'];
    case 'currency':
      return ['in', 'gt', 'gte', 'lt', 'lte', 'missing'];
    default:
      return ['in', 'not_in', 'missing'];
  }
};

export default getFilterOperators;
